export default {
  methods: {
    confirmDeleteAction({
      title = "Delete this item?",
      text = "This action cannot be undone.",
      confirmButtonText = "Delete"
    } = {}) {
      return this.$swal({
        title,
        text,
        type: "warning",
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText: "Cancel",
        showCloseButton: true,
        reverseButtons: true,
        focusCancel: true
      });
    }
  }
};